const MODAL_TYPE = {
  CREATE_ROOM_SUCCESS: 'CREATE_ROOM_SUCCESS',
  CREATE_PLACE_SUCCESS: 'CREATE_PLACE_SUCCESS',
  CREATE_PRICE_SUCCESS: 'CREATE_PRICE_SUCCESS',
  EDIT_PRICE_SUCCESS: 'EDIT_PRICE_SUCCESS',
  ADD_ADMINISTRATOR_SUCCESS: 'ADD_ADMINISTRATOR_SUCCESS',
};

export default MODAL_TYPE;
